/* eslint-disable import/prefer-default-export */
export class AppMappings {
  static VALES = 'cupones';

  static PROMOCIONES = 'promociones';

  static MAS_PROMOCIONES = 'maspromociones';

  static SALDO = 'saldo';

  static TARJETA_DIGITAL = 'tarjetadigital';

  static TRAVEL = 'travel';

  static AHORROS = 'ahorros';

  static TICKETS = 'tickets';

  static MIS_DATOS = 'misdatos';

  static lISTA_DE_LA_COMPRA = 'listadelacompra';

  static HOME = 'home';

  static ROOT_APP_ERO = 'eroski://link';

  static ROOT_APP_CPB = 'caprabo://link';
}
